import React, { Suspense, lazy } from "react";
import { ECLLoader, ECLPageWrapper } from "../../eclComponents";
import { translate } from "../../utilities/Translate";
import { Link, Route } from "react-router-dom";
import Explorer from "../../pages/sandbox/Explorer/Explorer";
import BPMNDemo from "../../pages/sandbox/BPMNDemo/BPMNDemo";

//SANDBOX PAGES
const SandboxPanelHome = lazy(
   () => import("../../pages/sandbox/SandboxPanelHome/SandboxPanelHome"),
);
const AnnotoriusExample = lazy(
   () => import("../../pages/sandbox/AnnotoriousExample/AnnotoriousExample"),
);
const Widgets = lazy(() => import("../../pages/sandbox/Widgets/Widgets"));
const SeanQLPage = lazy(
   () => import("../../pages/sandbox/SeanQLPage/SeanQLPage"),
);
const NotificationsSandbox = lazy(
   () => import("../../pages/sandbox/Notifications/Notifications"),
);
const SourceOneLaunchers = lazy(
   () => import("../../pages/sandbox/SourceOneLaunchers/sourceOneLaunchers"),
);
const RichTextEditorPage = lazy(
   () => import("../../pages/sandbox/RichTextEditor/RichTextEditorPage"),
);
const StyleExamples = lazy(
   () => import("../../pages/sandbox/StyleExamples/StyleExample"),
);
const FeatureFlags = lazy(
   () => import("../../pages/sandbox/FeatureFlagsPage/FeatureFlagsPage"),
);
const NewHire = lazy(() => import("../../pages/sandbox/NewHire/NewHire"));
const GPSDemo = lazy(() => import("../../pages/sandbox/GPSDemo/GPSDemo"));
const SCIMeditor = lazy(
   () => import("../../pages/sandbox/SCIMeditor/SCIMeditor"),
);

const WidgetsDemo = lazy(
   () => import("../../pages/sandbox/ECLWidgets/widgetsDemo"),
);
const FormSubmissionDemo = lazy(
   () => import("../../pages/sandbox/ECLWidgets/FormSubmission/FormSubmission"),
);
const DropDownPortalsExamples = lazy(
   () =>
      import("../../pages/sandbox/DropDownPortalsExamples/DropDownPortalsExamples"),
);
const WebViewerDemo = lazy(
   () => import("../../pages/sandbox/WebViewer/WebViewerSandbox"),
);
const ECLSelectCustomOnChange = lazy(
   () =>
      import("../../pages/sandbox/ECLWidgets/ECLSelectCustomOnChange/ECLSelectCustomOnChange"),
);
const ECLFormBlock = lazy(
   () => import("../../pages/sandbox/ECLWidgets/ECLFormBlock/SandboxFormBlock"),
);
const ECLImageUploader = lazy(
   () =>
      import("../../eclComponents/ECLInputs/ECLImageUploader/ECLImageUploader"),
);
const ThemeImageWork = lazy(
   () => import("../../pages/sandbox/ThemeImageWork/ThemeImageWork"),
);
const WebSocketTest = lazy(
   () => import("../../pages/sandbox/WebSocketTest/WebSocketTest"),
);
const FileUpload = lazy(
   () => import("../../pages/sandbox/FileUpload/FileUpload"),
);

const OntologyFlow = lazy(
   () => import("../../pages/sandbox/OntologyFlow/OntologyFlow"),
);
const BusinessLandingPage = lazy(
   () => import("../../pages/main/Business/BusinessLanding"),
);

const sandboxMenuData = [
   //THIS IS WHERE YOU DEFINE THE ROUTE SLUG,
   //THE LABEL FOR THE SANDBOX HOMEPAGE, AND THE COMPONENT TO BE TESTED
   {
      text: translate("Theme Image Work"), //text will appear as header on the page and text in link on SandboxPanelHome
      path: "theme-image-work", //sourceone/sandbox/<path>
      component: <ThemeImageWork />,
   },
   {
      text: translate("AnnotoriusExample"), //text will appear as header on the page and text in link on SandboxPanelHome
      path: "annotorius-example", //sourceone/sandbox/<path>
      component: <AnnotoriusExample />,
   },
   {
      text: translate("Widgets"),
      path: "widgets",
      component: <Widgets />,
   },
   {
      text: translate("SeanQL"),
      path: "seanql-editor",
      component: <SeanQLPage />,
   },
   {
      text: translate("Notifications"),
      path: "notifications",
      component: <NotificationsSandbox />,
   },
   {
      text: translate("SourceOneLaunchers"),
      path: "sourceone-launchers",
      component: <SourceOneLaunchers />,
   },
   {
      text: translate("RichTextEditorPage"),
      path: "rich-text-edit",
      component: <RichTextEditorPage />,
   },
   {
      text: translate("StyleExamples"),
      path: "styles",
      component: <StyleExamples />,
   },
   {
      text: translate("FeatureFlags"),
      path: "feature-flags",
      component: <FeatureFlags />,
   },
   {
      text: translate("NewHire"),
      path: "new-hire",
      component: <NewHire />,
   },
   {
      text: translate("GPSDemo"),
      path: "gps-demo",
      component: <GPSDemo />,
   },
   {
      text: translate("SCIMeditor"),
      path: "SCIM-editor",
      component: <SCIMeditor />,
   },
   {
      text: translate("WidgetsDemo"),
      path: "widgets-demo",
      component: <WidgetsDemo />,
   },
   {
      text: translate("FormSubmissionDemo"),
      path: "form-submission-demo",
      component: <FormSubmissionDemo />,
   },
   {
      text: translate("DropDownPortalsExamples"),
      path: "drop-down-portal",
      component: <DropDownPortalsExamples />,
   },
   {
      text: translate("Web Viewer"),
      path: "web-viewer",
      component: <WebViewerDemo />,
   },
   {
      text: translate("ECLSelect Custom OnChange"),
      path: "ecl-select-onchange",
      component: <ECLSelectCustomOnChange />,
   },
   {
      text: translate("ECLForm Block"),
      path: "ecl-form-block",
      component: <ECLFormBlock />,
   },
   {
      text: translate("ECLImageUploader"),
      path: "ecl-image-uploader",
      component: <ECLImageUploader />,
   },
   {
      text: translate("Web Socket Demo"),
      path: "web-socket",
      component: <WebSocketTest />,
   },
   {
      text: translate("Explorer"),
      path: "explorer",
      component: <Explorer />,
   },
   {
      text: translate("File Upload"),
      path: "file-upload",
      component: <FileUpload />,
   },

   {
      text: translate("BPMN DEMO"),
      path: "bpmn-demo",
      component: <BPMNDemo />,
   },
   {
      text: translate("Ontology Flow"),
      path: "onto-flow",
      component: <OntologyFlow />,
   },
   {
      text: translate("Business"),
      path: "Business",
      component: <BusinessLandingPage />,
   },
];

//DON'T MESS WITH ANYTHING BELOW THIS PROBABLY///////////////////////

const sandboxPages = sandboxMenuData.map((ele, i) => (
   <Route
      key={`sandbox-${i + 1}`}
      exact
      path={`/sourceone/sandbox/${ele.path}`}
      element={
         <Suspense fallback={<ECLLoader />}>
            <ECLPageWrapper>
               <div
                  style={{
                     borderBottom: "solid 1px grey",
                     display: "flex",
                     flexDirection: "row",
                     justifyContent: "space-between",
                     alignItems: "center",
                  }}
               >
                  <h3>{ele.text}</h3>
                  <Link to={"/sourceone/sandbox"}>
                     Back to Sandbox Home Page
                  </Link>
               </div>
               {ele.component}
            </ECLPageWrapper>
         </Suspense>
      }
   />
));

export const sandboxRoutes = [
   //HOME PAGE
   <Route
      key={`sandbox-0`}
      exact
      path="/sourceone/sandbox"
      element={
         <Suspense fallback={<ECLLoader />}>
            <ECLPageWrapper>
               <SandboxPanelHome data={sandboxMenuData} />
            </ECLPageWrapper>
         </Suspense>
      }
   />,

   //SANDBOX ROUTES
   ...sandboxPages,
];
